// @flow
'use strict';

import * as React from 'react';

import type { IPisStQtde } from '../../../../../types_imposto';

import RowDetalhes from '../../../../../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../../../../../common/detalhes_documento/column_detalhes';

type PisStQtdeProps = {
  item : IPisStQtde,
};

export default function PisStQtde({ item } : PisStQtdeProps) {
  return (
      <RowDetalhes data={ item }>
        <ColumnDetalhes field="qtdVendida" width="25%">Quantidade Vendida</ColumnDetalhes>
        <ColumnDetalhes field="valorAliquota" type="moeda" width="25%">Alíquota do PIS</ColumnDetalhes>
        <ColumnDetalhes field="valorPis" type="moeda" width="25%">Valor do PIS</ColumnDetalhes>
      </RowDetalhes>
  );
}
